import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Typography,
  CircularProgress,
  IconButton,
  Box,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function ChangePassword({
  open,
  onClose,
  setChangePassword,
  currentUser,
  isAuthenticated,
}) {
  const [isError, setIsError] = useState("");
  const [msg, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const rfOldPassword = useRef();
  const rfNewPassword = useRef();
  const rfConfirmNewPassword = useRef();

  const handleClose = () => {
    if (onClose) onClose();
    if (setChangePassword) setChangePassword(false);
  };

  const validatePassword = (newPassword, confirmNewPassword) => {
    return newPassword === confirmNewPassword;
  };

  const changePassword = () => {
    if (!isAuthenticated || !currentUser) {
      setIsError("You have been logged out. Please log in again.");
      return;
    }
    const password = rfOldPassword.current?.value ?? "";
    const newPassword = rfNewPassword.current?.value ?? "";
    const confirmNew = rfConfirmNewPassword.current?.value ?? "";

    if (!password) {
      setIsError("Old password is required!");
      return;
    }
    if (!newPassword || newPassword.length < 6) {
      setIsError("New password must be at least 6 characters!");
      return;
    }
    if (!validatePassword(newPassword, confirmNew)) {
      setIsError("New password and Confirm password do not match");
      return;
    }

    setIsError("");
    setIsLoading(true);
    fetch(`/api/auth/${currentUser.UserID}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        Password: password,
        NewPassword: newPassword,
        ConfirmNewPassword: confirmNew,
      }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => {
        setIsLoading(false);
        if (data.success) {
          setMessage(data.success);
          localStorage.clear();
          setTimeout(() => {
            window.location.href = "/login";
          }, 1000);
        } else setIsError(data.error || "Could not change password");
      })
      .catch(() => {
        setIsLoading(false);
        setIsError("Could not change password!");
      });
  };

  if (!currentUser) return null;

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Change Password for {currentUser.Name}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
          size="small"
        >
          <IoClose size={24} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {msg && (
          <Typography color="primary" sx={{ mb: 2 }}>
            {msg}
          </Typography>
        )}
        {isError && (
          <Typography color="error" sx={{ mb: 2 }}>
            {isError}
          </Typography>
        )}
        <Box
          component="form"
          onSubmit={(e) => e.preventDefault()}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <TextField
            inputRef={rfOldPassword}
            label="Enter Old Password *"
            type="password"
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <TextField
            inputRef={rfNewPassword}
            label="Enter New Password *"
            type="password"
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <TextField
            inputRef={rfConfirmNewPassword}
            label="Confirm New Password *"
            type="password"
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={changePassword}
            sx={{ mt: 2 }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "Change Password"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
